module.exports = __webpack_public_path__ + "static/media/GH.9dd83570.svg";